import * as ko from "knockout";
import entityBase from "entityBase";
import { parseISO } from "date-fns";

export class person_cal_except extends entityBase {
  available: KnockoutObservable<string>;
  count_as_capacity: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  description: KnockoutObservable<string>;
  end_dttm: KnockoutObservable<Date>;
  exception_id: KnockoutObservable<number>;
  exception_type: KnockoutObservable<string>;
  fixed_commitment: KnockoutObservable<string>;
  modified_dttm: KnockoutObservable<Date>;
  person_id: KnockoutObservable<string>;
  start_dttm: KnockoutObservable<Date>;

  constructor(item: any) {
    super();
    this.available = ko.observable(item.available).extend({ maxLength: 1 });
    this.count_as_capacity = ko.observable(item.count_as_capacity).extend({ maxLength: 1 });
    this.created_by = ko.observable(item.created_by).extend({ maxLength: 32 });
    this.created_dttm = ko.observable(parseISO(item.created_dttm));
    this.description = ko.observable(item.description).extend({ maxLength: 256 });
    this.end_dttm = ko.observable(parseISO(item.end_dttm));
    this.exception_id = ko.observable(item.exception_id);
    this.exception_type = ko.observable(item.exception_type).extend({ maxLength: 32 });
    this.fixed_commitment = ko.observable(item.fixed_commitment).extend({ maxLength: 1 });
    this.modified_dttm = ko.observable(parseISO(item.modified_dttm));
    this.person_id = ko.observable(item.person_id).extend({ maxLength: 32 });
    this.start_dttm = ko.observable(parseISO(item.start_dttm));
  }
}
